/**
* @license Apache-2.0
*
* Copyright (c) 2025 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Scale a single-precision complex floating-point number by a real-valued single-precision floating-point scalar constant.
*
* @module @stdlib/complex/float32/base/scale
*
* @example
* import Complex64 from '@stdlib/complex/float32/ctor';
* import scale from '@stdlib/complex/float32/base/scale';
*
* var z = new Complex64( 5.0, 3.0 );
*
* var out = scale( 5.0, z );
* // returns <Complex64>[ 25.0, 15.0 ]
*/

// MODULES //

import setReadOnly from '@stdlib/utils/define-nonenumerable-read-only-property';
import main from './main.js';
import assign from './assign.js';
import strided from './strided.js';


// MAIN //

setReadOnly( main, 'assign', assign );
setReadOnly( main, 'strided', strided );


// EXPORTS //

export default main;

// exports: { "assign": "main.assign", "strided": "main.strided" }
